import React from "react";
import entrata from "../../assets/ingresso/saint.jpg";
import entrata1 from "../../assets/resFinal/port5.jpg";
import room1 from "../../assets/Landing/napoli-castel-dell-ovo.webp";
import room2 from "../../assets/1811Mobile/nap3.jpeg";
import nap from "../../assets/1811Mobile/nap.jpeg";

import { Stack } from "@mui/system";
const FooterGallery = () => {
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{ flexWrap: "wrap", justifyContent: "center", width: "100%" }}
    >
      {[
        {
          src: entrata,
          link: "https://www.instagram.com/1811_residenza_storica/",
        },
        { src: nap, link: "https://www.instagram.com/1811_residenza_storica/" },
        {
          src: room1,
          link: "https://www.instagram.com/1811_residenza_storica/",
        },
        {
          src: room2,
          link: "https://www.instagram.com/1811_residenza_storica/",
        },
        {
          src: entrata1,
          link: "https://www.instagram.com/1811_residenza_storica/",
        },
      ].map((item, index) => (
        <a
          key={index}
          href={item.link}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: "none",
            display: "inline-block",
            overflow: "hidden",
            width: "18%",
            paddingTop: "18%", // Mantiene il rapporto 1:1
            position: "relative",
          }}
        >
          <img
            src={item.src}
            loading="lazy"
            alt={`Instagram link ${index + 1}`}
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "100%",
              height: "100%",
              objectPosition: index === 0 ? "center 54%" : "center",
              objectFit: "cover", // Ritaglia l'immagine mantenendo il contenitore pieno
              transition: "transform 0.3s ease-in-out",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform =
                "translate(-50%, -50%) scale(1.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform =
                "translate(-50%, -50%) scale(1)";
            }}
          />
        </a>
      ))}
    </Stack>
  );
};

export default FooterGallery;
